export default class Engine {
  private frameRate: number
  private frameMillis: number
  private totalMillis: number

  public getFrameRate(): number {
    return this.frameRate
  }
  public getFrameMillis(): number {
    return this.frameMillis
  }
  public getTotalMillis(): number {
    return this.totalMillis
  }

  public constructor(frameRate: number) {
    this.frameRate = frameRate
    this.frameMillis = 1000 / this.frameRate
    this.totalMillis = 0
  }

  private _onUpdateHandlers: (() => any)[] = []
  public addOnUpdate(handler: () => any): void {
    this._onUpdateHandlers.push(handler)
  }
  public removeOnUpdate(handler: () => any): void {
    this._onUpdateHandlers = this._onUpdateHandlers.filter(x => x != handler)
  }
  private update(): void {
    for (let handler of this._onUpdateHandlers) {
      handler()
    }
  }

  private _onDrawHandlers: (() => any)[] = []
  public addOnDraw(handler: () => any): void {
    this._onDrawHandlers.push(handler)
  }
  public removeOnDraw(handler: () => any): void {
    this._onDrawHandlers = this._onDrawHandlers.filter(x => x != handler)
  }
  private draw(): void {
    for (let handler of this._onDrawHandlers) {
      handler()
    }
  }

  private paused = false
  private startMillis = 0
  private nextMillis = 0
  private pauseMillis = 0
  public pause(): void {
    this.paused = true
    this.pauseMillis = Date.now()
  }
  public resume(): void {
    let pausedMillis = Date.now() - this.pauseMillis
    this.startMillis += pausedMillis
    this.nextMillis += pausedMillis
    this.paused = false
  }

  public start(): void {
    this.startMillis = Date.now()
    this.nextMillis = Date.now()
    this.startClock(() => {
      while (!this.paused && Date.now() > this.nextMillis) {
        this.totalMillis = this.nextMillis - this.startMillis
        this.update()
        this.nextMillis += this.frameMillis
      }
      this.draw()
    })
  }
  public stop(): void {
    this.stopClock()
  }

  private clockActive = false
  private clockInterval = 0
  private startClock(callback: () => any): void {
    this.clockActive = true
    let w = window as any;
    if (w.requestAnimationFrame) {
      let tick: () => void
      tick = () => {
        if (this.clockActive) {
          callback()
          w.requestAnimationFrame(tick)
        }
      }
      tick()
    } else if (w.webkitRequestAnimationFrame) {
      let tick: () => void
      tick = () => {
        if (this.clockActive) {
          callback()
          w.webkitRequestAnimationFrame(tick)
        }
      }
      tick()
    } else if (w.mozRequestAnimationFrame) {
      let tick: () => void
      tick = () => {
        if (this.clockActive) {
          callback()
          w.mozRequestAnimationFrame(tick)
        }
      }
      tick()
    } else {
      this.clockInterval = setInterval(() => {
        if (this.clockActive) {
          callback()
        }
      }, this.frameMillis)
    }
  }
  private stopClock() {
    this.clockActive = false
    if (this.clockInterval) {
      clearInterval(this.clockInterval)
    }
  }
}